import { Title } from '@/components/Title';
import { WithDefaultLayout } from '../../../components/DefautLayout';
import { Page } from '../../../types/Page';
import Link from 'next/link';
import { BenefitPoint } from '@/components/program/BenefitPoint';
import { HeaderSection } from '@/components/common/headers/HeaderSection';
import { NewSkillBox } from '@/components/program/NewSkillBox';
import { SectionWorkshopProcedure } from '@/components/home/SectionWorkshopProcedure';
import { MobileAppCourseReason } from '@/components/course/section/MobileAppCourseReason';
import { BenefitBox } from '@/components/program/BenefixBox';
import BootcampFullStackEngineerSchedule from '@/components/course/schedule/BootcampFullStackEngineerSchedule';

const FullStackEngineerPage: Page = () => {
    return (
        <div>
            <Title title={'Bootcamp - Full Stack Engineer'} description='' />
            <section id='landing-page-full-stack-engineer' className='flex flex-wrap justify-between items-center bg-bg-bootcamp bg-cover bg-no-repeat bg-center'>
                <div className='text-2xl mx-5 mb-4'>
                    <div className='m-5 p-5'>
                        <img src='/img/layouting/logo-accelist-white.png' style={{ width: 74 }} alt='img' />
                        <p className='text-3xl font-bold text-accelist-green mb-3 md:mb-5 mt-4'>Bootcamp</p>
                        <p className='text-3xl md:text-3xl text-white font-bold mb-2'>Full Stack Engineer</p>
                        <p className='text-3xl md:text-3xl text-white font-bold mb-2'>From Zero to IT Hero: A Beginner&apos;s</p>
                        <p className='text-3xl md:text-3xl text-white font-bold mb-2'>Guide to IT Development</p>
                        <div className='w-fit bg-slate-900 rounded-lg px-2 py-2 mt-3 md:mt-5 text-center' style={{ width: 350 }}>
                            <p className='text-white text-base md:text-lg text-center px-2'>2 bulan menjadi Full Stack Engineer</p>
                        </div>
                        <p className='text-xl md:text-2xl text-white font-bold mt-4 md:mt-3'>Front-End dan Back-End untuk Website</p>
                        <p className='text-xl md:text-2xl text-white font-bold mt-4 md:mt-3'>dan Mobile Application</p>
                        <div className='flex flex-wrap mt-3'>
                            <BenefitBox name='Sertifikat Keahlian Terverifikasi DISNAKER'/>
                            <BenefitBox name='Sertifikat Penyelesaian Programming Online Course'/>
                            <BenefitBox name='Sesi Interaktif Expert via Online Meets'/>
                            <BenefitBox name='Real Project Perusahaan'/>
                        </div>
                        <div className="bg-accent-100 rounded-md hover:bg-black duration-300 flex justify-center items-center mt-6 mb-2" style={{ width: 200, height: 50 }}>
                            <Link href="/courses/register" className="block duration-300 text-white hover:text-white text-lg md:text-xl text-accelist-font">
                                Daftar Program
                            </Link>
                        </div>
                    </div>
                </div>
                <div className='mx-5 mb-4 justify-center'>
                    <p className='text-white text-center font-bold mb-3'>Software Skill:</p>
                    <div className='flex flex-wrap justify-center'>
                        <NewSkillBox name='C#' />
                        <NewSkillBox name='.NET' />
                        <NewSkillBox name='ASP.NET Core' />
                        <NewSkillBox name='HTML' />
                    </div>
                    <div className='flex flex-wrap justify-center'>
                        <NewSkillBox name='CSS' />
                        <NewSkillBox name='JavaScript' />
                        <NewSkillBox name='TypeScript' />
                        <NewSkillBox name='Node.js' />
                    </div>
                    <div className='flex flex-wrap justify-center'>
                        <NewSkillBox name='React' />
                        <NewSkillBox name='Next.js' />
                        <NewSkillBox name='Vercel' />
                        <NewSkillBox name='React Native' />
                    </div>
                    <div className='flex flex-wrap justify-center'>
                        <NewSkillBox name='Expo' />
                        <NewSkillBox name='Expo Application Service (EAS)' />
                        <NewSkillBox name='Tailwind CSS' />
                    </div>
                    <div className='flex flex-wrap justify-center'>
                        <NewSkillBox name='SQL' />
                        <NewSkillBox name='SQL Server' />
                        <NewSkillBox name='PostgreSQL' />
                    </div>
                    <div className='flex flex-wrap justify-center'>
                        <NewSkillBox name='Entity Framework Core' />
                    </div>
                </div>
            </section>
            <section id='program-description' className='bg-program-atas'>
                <div className='mx-24'>
                    <div>
                        <div className='flex flex-wrap items-center justify-center'>
                            <p className='text-4xl font-bold text-white mt-16 mb-5'>Full Stack Engineer</p>
                        </div>
                        <div className='text-2xl text-gray-400 flex items-center justify-center'>

                        </div>
                        <div className='flex items-center justify-center'>
                            <div className='border-2 md:border-4 border-accent-100 rounded-full w-40 mb-5' />
                        </div>
                    </div>
                    <div>
                        <div className='text-xl text-white'>
                            <p className='text-3xl font-bold text-white my-10'>Deskripsi</p>
                            <p>Full Stack Engineer merupakan salah satu kursus bagi para calon website dan mobile application engineer. Melalui kursus ini, para peserta akan memulai karirnya melalui pembelajaran, pembuatan, dan pengembangan website dan mobile application yang dapat diakses di seluruh perangkat. Kursus ini akan menghasilkan website dan mobile application yang menarik, interaktif, dan dapat diakses di internet atau smartphone anda.</p>
                        </div>
                    </div>
                    <p className='text-3xl font-bold text-white my-10'>Agenda dan Materi</p>
                    <div className='text-xl text-accelist-font flex flex-col flex-wrap text-white pb-10'>
                        <BenefitPoint name='Install development tools: Visual Studio, Visual Studio Code, Node.js, .NET, PostgreSQL, SQL Server, Expo' />
                        <BenefitPoint name='Pembelajaran bahasa pemrograman C# dan framework .NET' />
                        <BenefitPoint name='Pembelajaran pengembangan aplikasi back-end web API dengan ASP.NET Core' />
                        <BenefitPoint name='Pembelajaran pengembangan front-end web dengan React dan Next.js' />
                        <BenefitPoint name='Pembelajaran pengembangan aplikasi mobile (Android & iOS) dengan React Native dan Expo' />
                        <BenefitPoint name='Pembelajaran SQL, SQL Server, dan PostgreSQL' />
                        <BenefitPoint name='Pembelajaran integrasi Entity Framework Core dengan PostgreSQL' />
                        <BenefitPoint name='Latihan soal dan ujian pengembangan aplikasi berbasis project' />
                    </div>
                </div>
            </section>
            <section id='program-price' className='py-12'>
                <div className="flex flex-wrap px-5 md:px-16">
                    <div className="flex flex-col mx-auto text-center mb-4 md:mb-8 items-center">
                        <HeaderSection
                            title="Biaya Program"
                            subtitle="Biaya dan Durasi Program"
                        />
                    </div>
                    <div className="w-full relative p-5 rounded-xl bg-gradient-to-r from-gradientgold-50 via-gradientgold-60 to-gradientgold-50">
                        <div className="flex flex-wrap justify-between w-full pt-12  pl-5 pr-2 md:px-14 h-full bg-secondary-100 rounded-xl">
                            <div className='flex flex-col'>
                                <p className='text-2xl sm:text-4xl font-bold bg-gradient-to-r from-gradientgold-70 via-gradientgold-60 to-gradientgold-50 text-transparent bg-clip-text mb-6'>Full Stack Engineer</p>
                                <p className='text-2xl sm:text-6xl font-bold text-[#FEEC9B] mb-16'>Rp8,850,000</p>
                                <p className='text-md sm:text-xl font-bold text-[#B3B3B3] mb-5'>Rp221.350/hari</p>
                                <p className='text-md sm:text-xl font-bold text-[#B3B3B3] mb-1'>Senin-Jumat</p>
                                <p className='text-md sm:text-xl font-bold text-[#B3B3B3] mb-8'>Durasi 8 minggu, setiap Senin-Jumat, 8 jam per hari</p>
                                <p className='text-md sm:text-sm text-[#CDCDCD] mb-6'>Sudah bisa membuat Front-End Website, Mobile Application, dan Back-End Web API dengan coding</p>
                                <div className='w-fit bg-gradient-to-r from-[#A88322] via-[#FEEC9B] to-[#A88322] p-3'>
                                    <Link href="/courses/register" className='hover:bg-[#FEEC9B] duration-300 transition ease-in-out bg-gradient-to-r from-[#A88322] via-[#FEEC9B] to-[#A88322] rounded-md'>
                                        <p className='text-md sm:text-xl text-secondary-100 font-body font-bold'>Daftar Sekarang</p>
                                    </Link>
                                </div>
                            </div>
                            <img src='/img/program/detail-paket-gold.png' alt='' className='w-fit'></img>
                        </div>
                    </div>
                </div>
            </section>
            <section id='program-schedule' className='py-16'>
                <BootcampFullStackEngineerSchedule />
            </section>
            <section id='acquired-skills' className='pb-10'>
                <div className="flex flex-col flex-wrap px-5 md:px-16">
                    <div className="flex flex-col mx-auto text-center mb-8 md:mb-16 items-center">
                        <h2 className='text-secondary-100 text-2xl font-body font-bold align-center sm:text-4xl leading-relaxed'>Kenapa Harus Ikut Coding Kickstart: Full Stack Engineer?</h2>
                        <div className='border-2 md:border-4 border-accent-100 rounded-full w-40 mt-3 md:mt-5' />
                    </div>
                    <div className='flex flex-wrap justify-evenly'>
                        <MobileAppCourseReason />
                    </div>
                </div>
            </section>
            <section id='achieve-your-dream-with-us' className='bg-program-bawah'>
                <div className="flex flex-col flex-wrap px-5 md:px-16">
                    <div className="flex flex-col mx-auto text-center mb-8 md:mb-16 items-center mt-16">
                        <h2 className='text-white text-2xl font-body font-bold align-center sm:text-4xl leading-relaxed'>Wujudkan Mimpimu Bersama Kami</h2>
                        <p className="text-white text-base font-body font-light align-center mt-1 md:mt-3 sm:text-lg mb-16">Satu langkah untuk mewujudkan mimpi mu</p>
                        <Link href="/courses/register" className="text-sm sm:text-base font-medium font-body bg-accent-100  text-white py-2 px-4 sm:px-8 sm:py-3 rounded transition duration-300 ease-out hover:bg-white hover:text-accent-100 shrink">
                            <p className='text-md sm:text-xl font-body font-bold'>Daftar Program</p>
                        </Link>
                    </div>
                </div>
            </section>
            <SectionWorkshopProcedure />
            <section id='program-requirements' className='pb-20'>
                <div className="flex flex-col flex-wrap px-5 md:px-16">
                    <div className="flex flex-col mx-auto text-center mb-8 md:mb-16 items-center">
                        <h2 className='text-secondary-100 text-2xl font-body font-bold align-center sm:text-4xl mb-3 leading-relaxed'>Persyaratan Program</h2>
                        <p className="text-secondary-60 text-base font-body font-light align-center sm:text-lg">Minimum Spesifikasi Perangkat</p>
                        <div className='border-2 md:border-4 border-accent-100 rounded-full w-40 md:mt-5' />
                    </div>
                    <div className='flex flex-wrap justify-evenly'>
                        <div className='flex flex-wrap p-8 bg-white shadow-[4px_4px_6px_0px_#0D948838] mb-4 sm:mb-8 w-96'>
                            <img src="/img/program/laptop.png" alt="img" className="w-16 h-16" />
                            <div className='mx-4 mt-2 text-lg font-semibold'>
                                Komputer
                                <ul className='list-disc pl-6'>
                                    <li className='text-sm'>CPU: 4 Cores</li>
                                    <li className='text-sm'>RAM: 8 GB</li>
                                    <li className='text-sm'>Storage: 10 GB</li>
                                    <li className='text-sm'>OS: Windows/ Linux / macOS</li>
                                </ul>
                            </div>
                        </div>
                        <div className='flex flex-wrap p-8 bg-white shadow-[4px_4px_6px_0px_#0D948838] w-96'>
                            <img src="/img/course/icon-handphone.png" alt="img" className="w-16 h-16" />
                            <div className='mx-4 mt-2 text-lg font-semibold'>
                                Handphone
                                <ul className='list-disc pl-6'>
                                    <li className='text-sm'>Storage : 1 GB</li>
                                    <li className='text-sm'>OS: Android 5+ / iOS 13+</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="flex flex-col flex-wrap px-5 md:px-16">
                <div className="flex flex-col mx-auto text-center mb-8 md:mb-16 items-center">
                    <Link href="/courses/register" className="text-sm sm:text-base font-medium font-body text-white bg-accent-100 py-2 px-4 sm:px-8 sm:py-3 rounded transition duration-300 ease-out hover:bg-black hover:text-white shrink">
                        <p className='text-md sm:text-xl text-white font-body font-bold'>Daftar Sekarang</p>
                    </Link>
                </div>
            </div>
        </div>
    )
}

FullStackEngineerPage.layout = WithDefaultLayout;
export default FullStackEngineerPage;